import {makeStyles} from "@material-ui/core";
import {grey} from "@material-ui/core/colors";

export const useStyles = makeStyles((theme) => ({
  form: {
    padding: 0,
  },
  updateFileInput: {
    display: "none",
  },
  buttonText: {
    margin: `0 6px 0 ${theme.spacing(1)}px`,
  },
  fileText: {
    fontSize: 14,
    fontWeight: 500,
  },
  fileExt: {
    textTransform: "uppercase",
    color: grey[600],
  },
  actionsBlock: {
    display: "flex",
    justifyContent: "flex-end",
  },
  root: {
    width: "480px",
    padding: theme.spacing(3, 3, 2),
  },
  subTitle: {
    fontSize: 14,
    color: grey[600],
  },
  title: {
    fontSize: "24px",
    fontWeight: 500,
    marginBottom: theme.spacing(3),
  },
}));
